import {
  type Face,
  MARK,
  type Pose,
  bodyRimOutside,
  eye,
  gladFace,
  line,
  mouthArc,
  shut,
} from '../face-kit';
import { TAU, type Ctx } from '../paint';
import { swell } from './orage-moments';

const PUFFS: readonly (readonly [number, number, number])[] = [
  [-25, 8, 17],
  [-10, -10, 21],
  [13, -13, 20],
  [29, 4, 16],
  [2, 8, 22],
];
const BASE = [-40, 6, 80, 20, 10] as const;
const ROLLS = 3;

function cloud(ctx: Ctx): void {
  ctx.beginPath();
  for (const [x, y, radius] of PUFFS) {
    ctx.moveTo(x + radius, y);
    ctx.arc(x, y, radius, 0, TAU);
  }
  ctx.roundRect(...BASE);
}

function orage(ctx: Ctx, pose: Pose): void {
  const grown = 1 + swell(pose.t * 4);
  ctx.scale(grown, grown);
  bodyRimOutside(ctx, () => {
    cloud(ctx);
  });
  ctx.save();
  cloud(ctx);
  ctx.clip();
  ctx.lineWidth = 3;
  ctx.strokeStyle = 'rgb(255 255 255 / 0.14)';
  for (let index = 0; index < ROLLS; index += 1) {
    const from = pose.t * TAU + index * 2;
    ctx.beginPath();
    ctx.arc(-6 + index * 14, -6 + index * 4, 14 + index * 3, from, from + 2.2);
    ctx.stroke();
  }
  ctx.restore();
  if (shut(pose)) {
    eye(ctx, pose, -14, 6, 6);
    eye(ctx, pose, 14, 6, 6);
  } else {
    line(ctx, 6.5, [-26, -6], [-8, 1]);
    line(ctx, 6.5, [26, -6], [8, 1]);
    ctx.beginPath();
    ctx.ellipse(-14, 6, 5.5, 3.6, 0, 0, TAU);
    ctx.ellipse(14, 6, 5.5, 3.6, 0, 0, TAU);
    ctx.fillStyle = MARK;
    ctx.fill();
  }
  mouthArc(ctx, 0, 24, 9, 1.15, 1.85, 4);
}

function orageGlad(ctx: Ctx): void {
  gladFace(ctx, { eyeY: -2, mouthY: 8, mouthWidth: 13, part: 'smile' });
}

export const ORAGE_FACE: Face = {
  draw: orage,
  glad: orageGlad,
  frames: 16,
  loopBeats: 4,
  boss: true,
};
